import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { highlightPossibleResponse, resetSelectedIndex, playResponseAudio }
    from '../../../common/questions/questionsActions';
import PB_AUDIO_INSTRUCTIONS from '../../pbConstants';
import { GENERAL_AUDIO_DELAY, ONE_SECOND } from '../../../constants/time';

export const playPracticeScript = (questionSpecificAudio, possibleResponses) => async (dispatch) => {
    dispatch(highlightPossibleResponse(possibleResponses[0].id));
    await dispatch(playResponseAudio(possibleResponses[0].audio, 0, ONE_SECOND));
    dispatch(highlightPossibleResponse(possibleResponses[1].id));
    await dispatch(playResponseAudio(possibleResponses[1].audio, 1, GENERAL_AUDIO_DELAY));
    dispatch(highlightPossibleResponse(possibleResponses[2].id));
    await dispatch(playResponseAudio(possibleResponses[2].audio, 2, GENERAL_AUDIO_DELAY));
    dispatch(resetSelectedIndex());
    await dispatch(playAvatarAudio(
        PB_AUDIO_INSTRUCTIONS.questionsInstruction,
        GENERAL_AUDIO_DELAY,
    ));
    await dispatch(playStimulusAudio(
        questionSpecificAudio,
        GENERAL_AUDIO_DELAY,
    ));
    dispatch(highlightPossibleResponse(0));
    await dispatch(playAvatarAudio(
        PB_AUDIO_INSTRUCTIONS.practiceInstruction,
        GENERAL_AUDIO_DELAY,
    ));
    dispatch(resetSelectedIndex());
};

export const narratePracticeScreen = (questionSpecificAudio, possibleResponses) => async (dispatch) => {
    await dispatch(playAvatarAudio(
        PB_AUDIO_INSTRUCTIONS.questionsInstructionGeneral,
        GENERAL_AUDIO_DELAY,
    ));
    return dispatch(playPracticeScript(
        questionSpecificAudio,
        possibleResponses,
    ));
};

export const narratePracticeReadyScreen = () => (dispatch) => {
    dispatch(setAvatarInstructions([PB_AUDIO_INSTRUCTIONS.practiceInstructionReadyState]));
    return dispatch(playAvatarAudio([PB_AUDIO_INSTRUCTIONS.practiceInstructionReadyState]));
};
